module.exports = __webpack_public_path__ + "daedcdc2708ab5c04906b7550c9ed356.webp";